import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/layout/DashboardLayout';
import { Button } from '../components/ui/button';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function DepositSuccessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [amount, setAmount] = useState(0);
  const { t } = useLanguage();

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (!sessionId) { setStatus('error'); return; }

    const checkStatus = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API_URL}/api/payments/status/${sessionId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.payment_status === 'paid') {
          setStatus('success');
          setAmount(res.data.amount);
        } else {
          setStatus('pending');
        }
      } catch {
        setStatus('error');
      }
    };
    checkStatus();
  }, [searchParams]);

  return (
    <DashboardLayout>
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="bg-card border border-border rounded-2xl p-10 text-center max-w-md w-full" data-testid="deposit-result">
          {status === 'loading' && (
            <>
              <Loader2 className="h-16 w-16 text-accent mx-auto animate-spin mb-4" />
              <h2 className="text-xl font-semibold text-primary">{t('deposit_checking')}</h2>
            </>
          )}
          {status === 'success' && (
            <>
              <CheckCircle className="h-16 w-16 text-emerald-500 mx-auto mb-4" />
              <h2 className="text-xl font-semibold text-primary mb-2" data-testid="deposit-success-title">{t('deposit_success_title')}</h2>
              <p className="text-3xl font-bold text-accent mb-2">¥{amount?.toLocaleString()}</p>
              <p className="text-sm text-muted-foreground mb-6">{t('deposit_success_reflected')}</p>
              <Button onClick={() => navigate('/dashboard')} className="rounded-full" data-testid="go-dashboard-btn">
                {t('deposit_success_go_dashboard')}
              </Button>
            </>
          )}
          {status === 'pending' && (
            <>
              <Loader2 className="h-16 w-16 text-yellow-500 mx-auto mb-4" />
              <h2 className="text-xl font-semibold text-primary mb-2">{t('deposit_pending_title')}</h2>
              <p className="text-sm text-muted-foreground mb-6">{t('deposit_pending_desc')}</p>
              <Button onClick={() => navigate('/deposit')} variant="outline" className="rounded-full">
                {t('deposit_pending_back')}
              </Button>
            </>
          )}
          {status === 'error' && (
            <>
              <XCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
              <h2 className="text-xl font-semibold text-primary mb-2">{t('deposit_error_title')}</h2>
              <p className="text-sm text-muted-foreground mb-6">{t('deposit_error_desc')}</p>
              <Button onClick={() => navigate('/deposit')} variant="outline" className="rounded-full">
                {t('deposit_pending_back')}
              </Button>
            </>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}
